import { darken } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid grey',
    boxSizing: 'border-box',
    fontFamily: 'monospace'
  },

  inlineBlock: {
    display: 'inline',
    borderRadius: '0.25rem',
    paddingInline: '0.25rem',
    background: darken(theme.palette.secondary.main, 0.1),
    color: theme.palette.primary.main
  },

  multilineBlock: {
    display: 'inline-block',
    width: '100%',
    borderRadius: '0.5rem',
    padding: '0.5rem',
    background: darken(theme.palette.secondary.main, 0.25),
    color: 'white'
  }
}))

export default useStyles
